/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import OrderOfferRepository from '../../repositories/Admin/Stores/OrderOfferRepository';
import { createRestSlice } from '../../utils/RestSlice';

const orderOffersRestSlice = createRestSlice({
  resource: 'orderOffer',
  repository: OrderOfferRepository,
  slices: ['updateOrderOffer'],
});

const initialState = {
  ...orderOffersRestSlice.initialState,
};

const orderOffersSlice = createSlice({
  name: 'orderOffers',
  initialState,
  reducers: {
    ...orderOffersRestSlice.reducers,
  },
});

export default orderOffersSlice.reducer;

export const orderOffersRestHooks = orderOffersRestSlice.hooks(
  orderOffersSlice,
  ['admin', 'OrderOfferSlice']
);
